<div class="licensing-overlay" fxLayoutAlign="center center" *ngIf="!licenseState.licensed">

  <div fxLayout="column" fxLayoutAlign="start center" class="licensing-modal">

    <div class="logo-container">
      <img class="responsive" src="../../assets/images/logos/ls-premium.png" />
    </div>

    <div *ngIf="!licenseState.licensed && !verifyingLicense && isSuperAdmin" fxLayout="column" fxLayoutGap="12px">

      <div>
        <p>Little SIS is not currently licensed for <strong>{{this.license.domain}}</strong>.</p>
        <p *ngIf="this.license.subscriptions['ait-lsp'].plan.name === 'lapsed' || this.license.subscriptions['ait-lsp'].plan.name === 'paid'">Your license expired on {{this.license.subscriptions['ait-lsp'].expiry | date: 'MM/dd/yyyy'}}.</p>
        <p *ngIf="this.license.subscriptions['ait-lsp'].plan.name === 'unlicensed'">Request a quote using the link below to secure a 30 day trial license.</p>
      </div>

      <div *ngIf="this.license.subscriptions['ait-lsp'].plan.name === 'lapsed' || this.license.subscriptions['ait-lsp'].plan.name === 'paid'" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
        <button mat-flat-button (click)="getQuote()" [color]="'primary'">Renew your license</button>
        <button mat-flat-button (click)="verifyLicense()">Re-check license</button>
      </div>

      <div *ngIf="this.license.subscriptions['ait-lsp'].plan.name === 'trial' || this.license.subscriptions['ait-lsp'].plan.name === 'unlicensed'" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
        <button mat-flat-button [color]="'primary'" (click)="getQuote()">Request a quote </button>
        <button mat-flat-button (click)="verifyLicense()">Re-check license</button>
      </div>

      <div fxLayoutAlign="center center">
        <button mat-flat-button (click)="logout()" [color]="'warn'">Logout</button>
      </div>

      <div *ngIf="this.license.subscriptions['ait-lsp'].plan.name === 'lapsed' ||
                  this.license.subscriptions['ait-lsp'].plan.name === 'unlicensed'"
           fxLayout="row" fxLayoutAlign="center center">
        <button mat-button [color]="'error'" (click)="requestDataDeletion()">Request data deletion</button>
      </div>

    </div>

    <div *ngIf="!licenseState.licensed && !verifyingLicense && !isSuperAdmin" fxLayout="column" fxLayoutAlign="center center">

      <div>
        <p>Your license for Little SIS expired on {{this.license.subscriptions['ait-lsp'].expiry | date: 'MM/dd/yyyy'}}.</p>
        <p>Please contact your domain administrator to renew your license.</p>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
        <button mat-flat-button (click)="verifyLicense()">Re-check license</button>
        <button mat-flat-button (click)="logout()" [color]="'primary'">Logout</button>
      </div>

    </div>


    <div *ngIf="licenseState.licensed && !verifyingLicense" fxLayout="column" fxLayoutAlign="center center">

      <div fxLayout="column" fxLayoutAlign="center center">

        <mat-icon class="icon-60 success">check_circle_outline</mat-icon>

        <p>
          Little SIS is licensed to <strong>{{this.license.domain}}</strong> until {{this.license.subscriptions['ait-lsp'].expiry | date: 'MM/dd/yyyy'}}.
        </p>
      </div>

      <mat-icon class="icon-60 success">check_circle_outline</mat-icon>
      <p>Great! You have a license for Little SIS for your Google domain.</p>

    </div>

    <div *ngIf="verifyingLicense" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">

      <mat-progress-spinner [diameter]="60"
                            [color]="'primary'"
                            [mode]="'indeterminate'">
      </mat-progress-spinner>

      <div class="loading">
        <span>Checking license</span>
        <animated-ellipsis></animated-ellipsis>
      </div>

    </div>

  </div>

</div>
